import React from "react";
import CellLinked from "./CellLinked";
import RadioButton from "../../RadioButton";

type CellWithRadioLinkedProps = {
    value?: string | null;
    id?: string | null;
    link?: string | null;
    maxLength?: number;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    name?: string;
};

function CellWithRadioLinked({
    value = null,
    id = null,
    link = null,
    maxLength = 20,
    onChange = () => {},
    name,
}: CellWithRadioLinkedProps) {
    return (
        <div className="table-cell_radio" id={id}>
            <RadioButton label="" name={name} onChange={onChange} value={id ?? undefined} />
            <CellLinked value={value ?? undefined} link={link ?? undefined} maxLength={maxLength} />
        </div>
    );
}


export default CellWithRadioLinked;
